// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K1QhsoxPQ8wjwlV_s3UX{flex-direction:column;flex-grow:1;height:100%;display:flex}.F6drB9ywHwucWYYDTNOH{flex-grow:1;display:flex;position:relative}.Mh2rkDeDeM9LvHDpnfDX{flex-direction:column;gap:4px;padding:10px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `K1QhsoxPQ8wjwlV_s3UX`,
	"table": `F6drB9ywHwucWYYDTNOH`,
	"name": `Mh2rkDeDeM9LvHDpnfDX`
};
export default ___CSS_LOADER_EXPORT___;
